import { render, staticRenderFns } from "./CabeceraModalSimVista.vue?vue&type=template&id=4392a245&scoped=true&"
import script from "./CabeceraModalSimVista.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalSimVista.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalSimVista.vue?vue&type=style&index=0&id=4392a245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4392a245",
  null
  
)

export default component.exports